import "@hebeta/favorite/js/Favorite";
